import * as React from 'react';
import { Copy } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { useClipboard } from 'use-clipboard-copy';
import { notifySuccess } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Block, BlockHeading, Button, HeadingIcon, Text, Base } from '@gandi/ui';
import { useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { ListBlock } from '../../ListBlock';
import { Header as NextStepsHeader } from '../Header';
import { usePaymentTypeTranslation, useTitle } from './modules/helpers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "OfflinePayment-root_3AOmn",
  "infoRow": "OfflinePayment-infoRow_iGGKF",
  "label": "OfflinePayment-label_3X4vJ",
  "content": "OfflinePayment-content_p3VCD"
};
const displayBlock = {
  display: 'block'
};
const InfoItem = value => /*#__PURE__*/_jsx("span", {
  style: displayBlock,
  children: value
}, `destination-info-item-${value}`);
const CheckInfoRow = info => {
  const values = info.values.filter(Boolean);
  const items = values.map(InfoItem);
  const title = items.shift();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Base, {
      weight: "semibold",
      children: title
    }), /*#__PURE__*/_jsx("div", {
      children: items
    })]
  }, info.label);
};
const InfoRow = (info, idx) => {
  const dispatch = useDispatch();
  const {
    __
  } = useTranslator();
  const FFShopConfirmationNDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');
  const values = info.values.filter(Boolean);
  const items = values.map(InfoItem);
  const {
    copy
  } = useClipboard({
    copiedTimeout: 500,
    onSuccess() {
      dispatch(notifySuccess(__('Successfully copied')));
    }
  });
  const text = values.join('\n');
  function onCopy() {
    copy(text);
  }
  if (FFShopConfirmationNDS) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.infoRow,
      children: [/*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        className: styles.label,
        children: info.label
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: items
      }), text && /*#__PURE__*/_jsx(Button, {
        type: "button",
        kind: "ghost",
        onClick: onCopy,
        children: /*#__PURE__*/_jsx(Copy, {
          size: 16
        })
      })]
    }, info.label);
  }
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    flexJustifyBetween: true,
    flexWrap: true,
    gap: "xsmall",
    marginBottom: "small",
    children: [/*#__PURE__*/_jsx(Text, {
      children: info.label
    }), /*#__PURE__*/_jsx(Base, {
      tagName: "p",
      weight: "semibold",
      align: "end",
      margin: "none",
      children: items
    })]
  }, idx);
};
export default function OfflinePayment({
  order
}) {
  const FFShopConfirmationNDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');
  const title = useTitle(order);
  const props = typeof title === 'string' ? {
    children: title
  } : {
    dangerouslySetInnerHTML: title
  };
  const paymentTypeTranslation = usePaymentTypeTranslation(order);
  if (!paymentTypeTranslation) {
    return null;
  }
  if (FFShopConfirmationNDS) {
    return /*#__PURE__*/_jsxs("section", {
      children: [/*#__PURE__*/_jsx(NextStepsHeader, {
        ...props
      }), /*#__PURE__*/_jsx(ListBlock, {
        className: styles.root,
        children: order.payment_type !== 'check' ? paymentTypeTranslation.content.map(InfoRow) : paymentTypeTranslation.content.map(CheckInfoRow)
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Block, {
    children: [/*#__PURE__*/_jsxs(BlockHeading, {
      fontSize: "m",
      children: [/*#__PURE__*/_jsx(HeadingIcon, {
        name: "arrowRight"
      }), paymentTypeTranslation.title]
    }), paymentTypeTranslation.content.map(InfoRow)]
  });
}